import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_FORECLOSURE } from 'config/formSections/financial';

import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { DateSummary, Summary } from 'components/Summary';
import ForeclosureItem from './ForeclosureItem';

const sectionConfig = {
  key: FINANCIAL_FORECLOSURE.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_FORECLOSURE.name,
  storeKey: FINANCIAL_FORECLOSURE.storeKey,
};

export class Foreclosure extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasForeclosure: this.props.HasForeclosure,
      List: this.props.List,
      ...queue,
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const date = DateSummary(o.When);
    const courtName = (o.CourtName || {}).value || '';

    return Summary({
      type: i18n.t('financial.pvq.foreclosure.summary.type'),
      index,
      left: courtName,
      right: date,
      placeholder: i18n.t('financial.pvq.foreclosure.summary.unknown'),
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasForeclosure = (values) => {
    this.update({
      HasForeclosure: values,
      List: values.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content foreclosure"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_FORECLOSURE.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.foreclosure')}</h1>
        <Branch
          name="has_foreclosure"
          label={i18n.t('financial.pvq.foreclosure.branch.title')}
          labelSize="h4"
          className="foreclosure-branch"
          {...this.props.HasForeclosure}
          warning
          onUpdate={this.updateHasForeclosure}
          required={required}
          scrollIntoView={scrollIntoView}
          onError={this.handleError}
          attribute="HasForeclosure"
        />
        <Show when={(this.props.HasForeclosure || {}).value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            summary={this.summary}
            errors={accordionErrors}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.foreclosure.appendTitle')}
            attribute="List"
          >
            <ForeclosureItem
              name="Item"
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

Foreclosure.defaultProps = {
  List: EmptyListInstance,
  HasForeclosure: {},
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(Foreclosure, sectionConfig);
